export default "__VITE_ASSET__ba949f77__"